<template>
  <c-modal v-model="showModal" :tag="false" hide-footer hide-header>
    <template>
<!--      {{item}}-->
      <div class="bold-text">{{item.Name}}</div>
      <div>
        <item-options :value="options"/>
      </div>
      <hr/>
      <price-information simple v-if="isMultiPrice(item)" :food="item"/>
      <hr v-if="isMultiPrice(item)"/>
      <section>
        <div v-for="(modifier, index) in item.ModifierCategories" :key="modifier.ModifierCategoryID" :class="index < item.ModifierCategories.length - 1 ? 'mb-3 border-bottom pb-3' : ''">
          <div class="d-flex justify-content-between mb-2">
            <span>{{modifier.ModifierCategory}}</span>
            <span>
              <template v-if="modifier.IsOptional">Optional</template>
              <template v-else>Required</template>
              <span class="bold-text">
              ({{modifier.ChoiceOption + ' ' +modifier.ChoiceNumber}})
              </span>
            </span>
          </div>
          <div style="color: #607d8b" class="d-flex justify-content-between" v-for="modItem in modifier.ModifierItems" :key="`modItem${modItem.ModifierID}`">
            <span>{{'- ' + modItem.ModifierName}}</span>
            <span>
              +<currency-display :value="modItem.Price"/>
            </span>
          </div>
        </div>
      </section>
    </template>
  </c-modal>
</template>

<script>
  import CModal from "../../../shared/Cmodal";
  import ItemOptions from "./itemOptions";
  import CurrencyDisplay from "../../../shared/currencyDisplay";
  import PriceInformation from "./priceInformation";
  export default {
    name: "modifierInformation",
    components: {PriceInformation, CurrencyDisplay, ItemOptions, CModal},
    props: {
      item: {
        required: true,
        default: () => ({})
      },
      value: {
        type: Boolean,
        default: false
      },
      options: {
        required: true
      }
    },
    computed: {
      showModal: {
        get () {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      isMultiPrice (food) {
        const prices = [food.Price, food.Price1, food.Price2, food.Price3, food.Price4]
        return prices.filter(item => item >= 0).length > 1 ? true : false
      },
    }
  }
</script>

<style scoped>

</style>
